import { useState } from "react";
import { useDispatch } from "react-redux";

import { Dialog } from "@mui/material";

import { QuickAdd } from "components/QuickAdd";

import { i18n } from "services/i18nService";
import { postRecord } from "services/sosInventoryService/sosApi";

import { Vendor } from "views/Vendors/Vendor/Vendor";

import { openAlert } from "globalState/alertSlice";
import {
  editModalLoadingIndicatorOn,
  editModalLoadingIndicatorOff,
} from "globalState/loadingSlice";

import { EDIT_MODAL_STYLES } from "editConfig";

export function QuickAddVendor(props) {
  const { open, onClose, initialNameValue, onAdd } = props;

  const [full, setFull] = useState(false);
  const [name, setName] = useState(initialNameValue);

  const dispatch = useDispatch();

  async function onQuickAdd() {
    dispatch(editModalLoadingIndicatorOn());
    const vendorRecord = { name, showOnForms: true };
    const { success, record, message } = await postRecord(
      "vendor",
      vendorRecord
    );
    if (success) {
      await onAdd(record);
    } else {
      const errorMessage = message || i18n("alert.ErrorCreatingNewVendor");
      dispatch(openAlert({ type: "error", message: errorMessage }));
    }
    dispatch(editModalLoadingIndicatorOff());
  }

  const dialogOptions = full ? EDIT_MODAL_STYLES : {};

  return (
    <Dialog open={open} onClose={onClose} {...dialogOptions}>
      {full ? (
        <Vendor
          key={open}
          name={name}
          onAdd={onAdd}
          onClose={onClose}
          fromForm={true}
        />
      ) : (
        <QuickAdd
          name={name}
          onClose={onClose}
          setFull={setFull}
          onQuickAdd={onQuickAdd}
          label={i18n("global.Name")}
          title={i18n("global.AddNewVendor")}
          ctaText={i18n("global.AddMoreVendor")}
          onValueChange={(_, value) => setName(value)}
        />
      )}
    </Dialog>
  );
}
